<template>
  <SmDropdown
    :items="filteredTags"
    :selected="selected"
    dropdown-class="w-60 p-2"
    divider
    :close-on-click-inside="false"
    @select="tagClickHandler">
    <!-- Trigger -->
    <template #trigger>
      <slot />
    </template>

    <SmInput
      v-if="props.availableTags.length > 0"
      v-model="searchQuery"
      outline
      size="medium"
      class="p-2"
      :label="i18n.t('search')">
    </SmInput>
    <div class="max-h-60 overflow-y-auto pb-1">
      <!-- Items -->
      <SmDropdownItem
        v-for="item in filteredTags"
        :key="item._id"
        divider
        :value="item._id"
        @click="tagClickHandler(item._id)">
        <div class="tag-row">
          <TagComponent
            :tag="{
              color: { ...generateFallbackColor(), ...item.color },
              name: item.name,
            }" />
          <Check
            v-if="selected.includes(item._id)"
            class="text-contrast"
            :size="18" />
        </div>
      </SmDropdownItem>
    </div>

    <hr v-if="props.availableTags.length > 0" />
    <!-- Add new -->
    <SmDropdownItem
      v-if="showCreateTag"
      :value="null"
      class="pt-3"
      @click="emit('createTag')">
      <div class="tag-row !justify-start">
        <Plus class="text-contrast" :size="18" />
        <span>{{
          props.createI18nKey ? i18n.t(props.createI18nKey) : i18n.t('addNew')
        }}</span>
      </div>
    </SmDropdownItem>
  </SmDropdown>
</template>

<script setup lang="ts">
  import { AccountGroup, Tag } from '@/client'
  import { generateFallbackColor } from '@/utils/colors'
  import { Check, Plus } from 'lucide-vue-next'
  import { useI18n } from 'vue-i18n'

  const i18n = useI18n()

  const props = defineProps<{
    showCreateTag?: boolean
    createI18nKey?: string
    selected: string[]
    availableTags: Tag[] | AccountGroup[]
  }>()

  const emit = defineEmits<{
    deleteTag: [value: string]
    addTag: [value: string]
    createTag: []
  }>()

  function tagClickHandler(tagId: string) {
    if (props.selected.includes(tagId)) emit('deleteTag', tagId)
    else emit('addTag', tagId)
  }

  const searchQuery = ref('')

  const filteredTags = computed(() => {
    if (!searchQuery.value) return props.availableTags
    return props.availableTags.filter((tag) =>
      tag.name.toLowerCase().includes(searchQuery.value.toLowerCase())
    )
  })
</script>

<style scoped lang="scss">
  .tag-row {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    gap: 0.5rem;
    height: 100%;
    padding: 0.1rem;
    cursor: pointer;
  }
</style>
